module.exports = __webpack_public_path__ + "static/media/flooring.763212c6.svg";